import { Dropdown } from "react-bootstrap";

const TitleBarMenu = ({children, className="", disabled=false}) => {

    return (
        <Dropdown data-bs-theme="dark">
            <Dropdown.Toggle variant="link" disabled={disabled} className={"hov-bg-black d-flex p-1 no-toggle-icon rounded-circle"+className}>
                <box-icon size="md" name='dots-vertical-rounded' color='white' ></box-icon>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {children}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default TitleBarMenu;